import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const app = initializeApp({
  apiKey: "AIzaSyC4r0NZxEgvUPy3Yb_Mp6P0L9h8CwMzzew",
  authDomain: "nestiy-6a9d7.firebaseapp.com",
  projectId: "nestiy-6a9d7",
  storageBucket: "nestiy-6a9d7.firebasestorage.app",
  messagingSenderId: "482392428890",
  appId: "1:482392428890:web:5d9d0290d936c6a8f1a363",
  measurementId: "G-QDW8SGC9FS"
});
export const authRef = getAuth(app);
